import * as React from "react";
const _ = require('lodash');
const ReactModal = require('react-modal');
import Accordian from "../accordian";
import SearchField from "../search-field";
export default class MobileFilter extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = () => {
            this.props.updateMobileToggle();
        };
        this.getPills = () => {
            let pills = [];
            _.forOwn(this.props.amenitesFilter, (value, key) => {
                if (value) {
                    pills.push(key);
                }
            });
            return pills;
        };
        this.customStyle = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                zIndex: 1000,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            },
            content: {
                background: '#fff',
                overflow: 'auto',
                WebkitOverflowScrolling: 'touch',
                outline: 'none',
                padding: '20px',
                width: '85%',
                height: '100%',
            }
        };
        this.customClasses = {
            afterOpen: 'afterOpen',
            base: 'base mobile-filter-modal',
            beforeClose: 'beforeClose'
        };
        this.customOverlayClasses = {
            afterOpen: 'afterOpen',
            base: 'base',
            beforeClose: 'beforeClose'
        };
        this.customAriaVariables = {
            labelledby: 'labelledby',
            describedby: 'describedby'
        };
    }
    render() {
        const deliveryObjs = [
            { name: "Special Events Ordering", value: "SpecialEventsOrdering" },
            { name: "Delivery Service", value: "DeliveryService" },
            { name: "Special Ordering", value: "SpecialOrdering" },
            { name: "Online Ordering", value: "OnlineOrdering" },
        ];
        const deliveryOptions = React.createElement("div", { className: "filter-options" }, deliveryObjs.map((filter, index) => {
            return React.createElement(SearchField, { key: index, selected: this.props.amenitesFilter[filter.value], onClick: () => { this.props.updateFilter(filter.value); }, label: filter.name });
        }));
        const storeObjs = [
            { name: "On Site Special Events", value: "OnSiteSpecialEvents" },
            { name: "Keg Sales", value: "KegSales" },
            { name: "On Site Kitchen", value: "OnSiteKitchen" },
            { name: "Sommelier On Staff", value: "SommelierOnStaff" },
            { name: "Licensee Sales", value: "LicenseeSales" },
        ];
        const storeOptions = React.createElement("div", { className: "filter-options" }, storeObjs.map((filter, index) => {
            return React.createElement(SearchField, { key: index, selected: this.props.amenitesFilter[filter.value], onClick: () => { this.props.updateFilter(filter.value); }, label: filter.name });
        }));
        const filtertext = {
            SpecialEventsOrdering: "Special Events Ordering",
            OnSiteSpecialEvents: "On Site Special Events",
            KegSales: "Keg Sales",
            OnSiteKitchen: "On Site Kitchen",
            DeliveryService: "Delivery Service",
            SpecialOrdering: "Special Ordering",
            OnlineOrdering: "Online Ordering",
            SommelierOnStaff: "Sommelier On Staff",
            LicenseeSales: "Licensee Sales",
        };
        let pillsStr = this.getPills();
        let style = {
            display: pillsStr.length > 0 ? "flex" : "none",
            marginTop: "1rem",
            borderBottom: "none"
        };
        let pills = pillsStr.map((pill, index) => {
            return React.createElement("li", { key: index, className: "filter-pills__list__item" },
                React.createElement("button", { className: "pill" },
                    React.createElement("span", null, filtertext[pill]),
                    React.createElement("i", { onClick: () => { this.props.updateFilter(pill); }, className: "fa fa-times", "aria-hidden": "true" })));
        });
        return (React.createElement(ReactModal, { isOpen: this.props.toggleMobile || false, onRequestClose: this.toggle, contentLabel: "filter label", style: this.customStyle, className: this.customClasses, overlayClassName: this.customOverlayClasses, bodyOpenClassName: 'bodyOpenClassName', aria: this.customAriaVariables },
            React.createElement("h2", { className: "filter-header", style: { display: "flex", alignItems: "center", borderBottom: "none" } },
                "Filters",
                React.createElement("i", { className: "fa fa-times", style: { marginLeft: "auto", cursor: "pointer" }, onClick: this.toggle })),
            React.createElement("div", { className: "applied", style: { borderBottom: "none" } },
                React.createElement("nav", { className: "filter-pills", style: style },
                    React.createElement("span", { className: "filter-pills__label" }, "Filters:"),
                    React.createElement("ul", { className: "filter-pills__list" },
                        pills,
                        React.createElement("li", { className: "filter-pills__list__item" },
                            React.createElement("button", { className: "clear-all", onClick: () => { this.props.clearFilter(); } }, "Clear All"))))),
            React.createElement(Accordian, { header: "Delivery & Ordering Options", content: React.createElement("div", { className: "acrd-list" }, deliveryOptions) }),
            React.createElement(Accordian, { header: "Store Features", content: React.createElement("div", { className: "acrd-list" }, storeOptions) })));
    }
}
;
//# sourceMappingURL=mobile-filter.js.map